import { useEffect, useRef, useState } from 'react'
import { getLiveMarkets } from './instruments'
import { MarketCard } from './MarketCard'
import './web-test-markets.css'

export function WebTestMarkets() {
  const rootRef = useRef<HTMLElement>(null)
  const [visible, setVisible] = useState(false)
  const markets = getLiveMarkets()

  useEffect(() => {
    const el = rootRef.current
    if (!el) return
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setVisible(true)
          io.disconnect()
        }
      },
      { threshold: 0.12 },
    )
    io.observe(el)
    return () => io.disconnect()
  }, [])

  return (
    <section
      ref={rootRef}
      id="markets"
      className={`wm-section${visible ? ' is-visible' : ''}`}
      aria-labelledby="wm-title"
    >
      <div className="wm-inner">
        <header className="wm-intro">
          <h2 id="wm-title" className="wm-title">
            Available Markets
          </h2>
          <p className="wm-subtitle">Structured prediction trading on Gold and Silver.</p>
        </header>

        <div className="wm-grid">
          {markets.map((market, index) => (
            <div
              key={market.id}
              className="wm-grid__item"
              style={{ ['--wm-i' as string]: index }}
            >
              <MarketCard market={market} />
            </div>
          ))}
        </div>

        <p className="wm-closing">Additional supported markets may be introduced over time.</p>
      </div>
    </section>
  )
}
